import { render, staticRenderFns } from "./AIAgent.vue?vue&type=template&id=7126f33b&scoped=true"
import script from "./AIAgent.vue?vue&type=script&lang=js"
export * from "./AIAgent.vue?vue&type=script&lang=js"
import style0 from "./AIAgent.vue?vue&type=style&index=0&id=7126f33b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7126f33b",
  null
  
)

export default component.exports